import {selectCurrentPlayer} from "../../redux/reducers/sharedStateReducer/selectors";
import {getSupplyFarms} from "./progress/getSupplyFarms";

/**
 * true, если у игрока есть хотя бы одна ферма, которая всё ещё может передать
 * снабжение: у фермы есть нераспределенное снабжение и его есть куда потратить
 * (см. getSupplyFarms — тот же подсчет дел снабжения показывает кнопка хода).
 * Раньше игроку показывали подтверждение завершения хода и тогда, когда
 * раздавать было некуда (найдено пользователем).
 *
 * @param state
 * @param hexGridRenderer - рендерер гексов (REGISTRY_SINGLETON.getHexGridRenderer())
 * @param [player] - чьи фермы проверять; по умолчанию текущий игрок. В
 * одновременной фазе снабжения сетевой игры текущий игрок — только якорь хода,
 * поэтому там передается действующий игрок (selectSupplyActingPlayer)
 */
export const checkIfPlayerHasSupplyCapableFarm = (state, hexGridRenderer, player) => {
  const checkedPlayer = player === undefined ? selectCurrentPlayer(state) : player;
  if (!checkedPlayer) {
    return false;
  }

  return getSupplyFarms(state, checkedPlayer, hexGridRenderer).actionableIds.length > 0;
};
